enum Domain
{
    USCR = 'uscyberrange',
    VACR = 'virginiacyberrange'
}
export default Domain;